module.exports = __webpack_public_path__ + "static/media/covid_adolescent_p5_1.65712618.png";